<template>
  <div>
    <div class="block" v-show="visible" @click="cancel"></div>

    <div class="del-popup" :class="[visible && 'bounceIn']" v-show="visible">
      <div class="header">
        <p>{{ title }}</p>
        <span class="top-close" @click="cancel"> <i class="el-icon-circle-close icon"></i> </span>
      </div>
      <!-- 内容 -->
      <div class="content">
        <div class="container">
          <el-scrollbar style="height:100%;" ref="scrollbar">
            <slot name="content"></slot>
          </el-scrollbar>
        </div>
        <div class="footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bus from '@/utils/eventBus.js';
export default {
  name: 'AiAssistentDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  model: {
    prop: 'visible',
    event: 'update'
  },
  data() {
    return {

    }
  },
  created() {
    bus.$on('scrollToBottom', res => {
      this.scrollToBottom()
    });
  },
  beforeDestroy() {
    bus.$off('scrollToBottom');
  },
  methods: {
    // 滚动到底部
    scrollToBottom() {
      this.$nextTick(() => {
        const scrollbar = this.$refs.scrollbar.$refs.wrap; // 获取滚动区域的DOM元素
        scrollbar.scrollTop = scrollbar.scrollHeight; // 设置滚动位置到底部
      });
    },
    // 关闭
    cancel() {
      this.$emit('update', false)
      this.$emit('close')
    },
  }
}
</script>
<style lang="scss" scoped>
.block {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  background: rgba(0, 0, 0, .1);
}

.del-popup {
  position: absolute;
  right: 100px;
  bottom: -20px;
  z-index: 9999;
  background: #fff;
  border-radius: 4px;

  .header {
    height: 32px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    font-weight: 500;

    .top-close {
      position: absolute;
      top: 8px;
      right: 8px;
      cursor: pointer;
      color: #a4a3a3;

      .icon {
        font-size: 14px;
      }
    }
  }

  .content {
    padding: 8px 12px;
    border-top: 1px solid #dedede;

    .container {
      width: 330px;
      height: 60vh;
      max-height: 500px;

      /deep/ .el-scrollbar {
        .el-scrollbar__wrap {
          overflow-x: hidden;
        }
      }
    }
  }
}

.bounceIn {
  animation-name: bounceIn;
}

@keyframes bounceIn {

  from,
  50%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  }

  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale3d(0, 0, 0)
  }

  50% {
    transform: translate(-50%, -50%) scale3d(1.1, 1.1, 1.1)
  }

  100% {
    opacity: 1;
    transform: translate(-50%, -50%) scale3d(1, 1, 1)
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/aiAssistent/aiAssistentDialog.vue